import * as gs from "@ivanlog/gs";
import { CmpWidgetChartBase } from "./tmpls";
import { App } from "../App";
import { Helper } from "../libs/Helper";

export class CmpWidgetChart extends CmpWidgetChartBase {

    constructor() {
        super();
        this._loadAsync();
    }

    async _loadAsync()
    {
        await Helper.awaitTime(500);
        const symbol = this.ctrls.chart.getData('symbol');
        const interval='5min';
        const container = this.ctrls.chart;
        if (!container) return;
        container.html='';
        let style={
            textColor:'#7072A2',
            background:'#080926'
        }
     
        const chartOptions = { 
            autoSize:true,
            layout: { textColor: style.textColor, background: { type: 'solid', color: style.background } },
                timeScale: {
                timeVisible: true,
                secondsVisible: false,
            },
            grid: {
                vertLines: {
                    color: '#242548',  // grid vert lines
                    style: 0,          // 0 — solid, 1 — dashed, 2 — dotted
                },
                horzLines: {
                    color: '#242548',  // grid hor lines
                    style: 0,
                },
            }
            };
        const chart = globalThis.LightweightCharts.createChart(container.el, chartOptions);
        const candlestickSeries = chart.addCandlestickSeries({
            upColor: '#04C9A1', downColor: '#B90042', borderVisible: false,
            wickUpColor: '#04C9A1', wickDownColor: '#B90042',
            priceFormat: {
                        type: 'price',
                    //  precision: 1,
                        minMove: 0.0000001
                    }
        });
        const dataResponce = await fetch("https://plusx.app/stats/"+symbol+"/candles_"+interval);
        const data = await dataResponce.json();
        for(const d of data) { d.time=d.timestamp;}
        candlestickSeries.setData(data);
        chart.timeScale().fitContent();
    }
}